<template>
    <div id="steps">
        <!--  HEADER STEP FLOWS -->
        <div class="ui fluid steps margin_center">
            <!-- STEP1 HEADER -->
            <div class="step" :class="{'active': current_step == 1, 'disabled': current_step < 1}">
                <div class="ui top left attached label button" @click="$parent.init()">
                    <i class="refresh icon"></i>
                    <!-- 重做 -->
                    {{ $t('ui.pages.uploader.redo') }}
                </div>
                <i v-if="is_processing == true && current_step == 1" class="notched circle loading icon"></i>
                <i v-else class="attached pointing right icon"></i>
                <div class="content">
                    <div class="title">
                        <!-- 訂單 -->
                        {{ $t('ui.pages.uploader.steps.title.operation') }}
                    </div>
                    <div class="description">
                        <!-- 指示本次託運內容 -->
                        {{ $t('ui.pages.uploader.steps.description.operation_content') }}
                    </div>
                </div>
            </div>
            <!-- STEP2 HEADER -->
            <div class="step" :class="{'active': current_step == 2, 'disabled': current_step < 2}">
                <i v-if="is_processing == true && current_step == 2" class="notched circle loading icon"></i>
                <i v-else class="browser icon"></i>
                <div class="content">
                    <div class="title">
                        <!-- 確認資料 -->
                        {{ $t('ui.pages.uploader.steps.title.confirm_data') }}
                        ({{checked_count}}/{{data_count}})
                    </div>
                    <div class="description">
                        <!-- 請確認資料是否正確 -->
                        {{ $t('ui.pages.uploader.steps.description.confirm_data_is_correct') }}
                    </div>
                </div>
            </div>
            <!-- STEP3 HEADER -->
            <div class="step" :class="{'active': current_step == 3, 'disabled': current_step < 3}">
                <i v-if="is_processing == true && current_step == 3" class="notched circle loading icon"></i>
                <i v-else class="cloud upload icon"></i>
                <div class="content">
                    <div class="title">
                        <!-- 上傳資料 -->
                        {{ $t('ui.pages.uploader.steps.title.upload_data') }}
                        ({{uploaded_count}}/{{data_count}})
                    </div>
                    <div class="description">
                        <!-- 將資料上傳至伺服器 -->
                        {{ $t('ui.pages.uploader.steps.description.upload_data_to_server') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UploaderSteps",
    props: {
        current_step: Number,
        checked_count: Number,
        uploaded_count: Number,
        data_count: Number,
        is_processing: Boolean,
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
